import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  saveButton: {
    backgroundColor: "#0B0909 !important",
    color: "white !important",
    fontWeight: "400 !important",
    marginRight: "10px !important",
    paddingLeft: "16px !important",
    paddingRight: "16px !important",
  },
    inputLabel: {
    color: "black  !important",
    fontWeight: "500 !important",
    fontFamily: "AvenirNext  !important",
    fontSize: "13px  !important",
    marginBottom: "4px  !important",
  },
}));

